// @flow
import React from 'react';
import CardCarousel from '@homeaway/react-card-carousel';
import LoadingCard from './LoadingCard/LoadingCard';
import {DESKTOP_CARDS_MAX_LIMIT} from './constants';

type Props = {
    isMobile: boolean,
    title: string,
    breakpoints: Object
};

const PropertyCarouselPlaceholder = (props: Props) => {
    const {isMobile, title, breakpoints} = props;

    const placeholdersArray = Array.from(
        {length: DESKTOP_CARDS_MAX_LIMIT},
        (item, index) => index + 1
    );
    const placeholders = placeholdersArray.map((value) => (
        <LoadingCard key={value} />
    ));

    return (
        <CardCarousel
            breakpoints={breakpoints}
            scrolling={isMobile}
            title={title}
        >
            {placeholders}
        </CardCarousel>
    );
};

export default PropertyCarouselPlaceholder;
